<template>
  <div class="settings-patient-portal-container m-4 p-2">
    <div
      class="d-flex flex-row justify-content-between align-items-center mb-3"
    >
      <h5 class="mb-0">Patient Portal</h5>
    </div>
    <b-form-group>
      <div cols="3" class="d-flex">
        <vue-toggles
          @click="appointmentRequestEnableToggleChangeState()"
          :value="appointmentRequestEnable"
          height="20"
          width="30"
          checkedBg="#34C759"
          uncheckedBg="#FF6161"
        />
        <small class="ml-2">Enable patient appointment request</small>
      </div>
    </b-form-group>
    <b-row>
      <b-col>
        <b-form-group label="Place appointments:">
          <b-form-select
            v-model="placeAppointmentsSelect"
            :options="placeAppointmentsOptions"
            size="sm"
            style="width: 165px;"
          ></b-form-select>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-form-group label="Clients can request appointments:">
          <b-form-select
            v-model="availableTimeBeforeSelect"
            :options="availableTimeBeforeOptions"
            size="sm"
            style="width: 100px;"
          ></b-form-select>
          <small> before start time, and up to </small>
          <b-form-select
            v-model="availableTimeInAdvanceSelect"
            :options="availableTimeInAdvanceOptions"
            size="sm"
            style="width: 100px;"
          ></b-form-select>
          <small> in advance.</small>
        </b-form-group>
      </b-col>
    </b-row>
    <b-form-group>
      <div class="d-flex">
        <vue-toggles
          @click="appointmentRequestNewPatientEnableToggleChangeState()"
          :value="appointmentRequestNewPatientEnable"
          height="20"
          width="30"
          checkedBg="#34C759"
          uncheckedBg="#FF6161"
        />
        <small class="ml-2">New patients can request appointment</small>
      </div>
    </b-form-group>
    <b-form-group>
      <div class="d-flex">
        <vue-toggles
          @click="appointmentRequestNewPatientInformationToggleChangeState()"
          :value="appointmentRequestNewPatientInformation"
          height="20"
          width="30"
          checkedBg="#34C759"
          uncheckedBg="#FF6161"
        />
        <small class="ml-2"
          >Request insurance information for new patients</small
        >
      </div>
    </b-form-group>
    <b-form-group>
      <div class="d-flex">
        <vue-toggles
          @click="appointmentRequestNewClientScheduleSameDayToggleChangeState()"
          :value="appointmentRequestNewClientScheduleSameDay"
          height="20"
          width="30"
          checkedBg="#34C759"
          uncheckedBg="#FF6161"
        />
        <small class="ml-2"
          >New clients can request same day appointments</small
        >
      </div>
    </b-form-group>
    <b-row>
      <b-col>
        <b-form-group
          label="Default status for documents completed in the Patient Portal:"
        >
          <b-form-select
            v-model="patientPortalDefaultDocumentStatus"
            :options="documentStatus"
            size="sm"
            style="width: 165px;"
          ></b-form-select>
        </b-form-group>
      </b-col>
    </b-row>
    <b-button variant="primary mt-3" @click="updateData()">
      Save
    </b-button>
  </div>
</template>

<script>
import systemSettingServer from "../../server/systemSetting";
import { mapActions, mapState } from "vuex";

export default {
  name: "PatientPortal",
  data() {
    return {
      appointmentRequestEnable: false,
      appointmentRequestNewPatientEnable: false,
      appointmentRequestNewPatientInformation: false,
      appointmentRequestNewClientScheduleSameDay: true,
      placeAppointmentsSelect: null,
      availableTimeBeforeSelect: null,
      availableTimeInAdvanceSelect: null,
      patientPortalDefaultDocumentStatus: null,
      placeAppointmentsOptions: [
        { value: "ByServiceDuration", text: "By Service duration" },
        { value: "OnTheFullHour", text: "On the full hour" },
        { value: "OnTheHalfHour", text: "On the half hour" },
        { value: "OnTheQuarterHour", text: "On the quarter hour" }
      ],
      availableTimeBeforeOptions: [
        { value: "OneHour", text: "1 hour" },
        { value: "TwelveHours", text: "12 hours" },
        { value: "OneDay", text: "1 day" },
        { value: "TwoDays", text: "2 days" },
        { value: "ThreeDays", text: "3 days" },
        { value: "FiveDays", text: "5 days" }
      ],
      availableTimeInAdvanceOptions: [
        { value: "OneWeek", text: "1 week" },
        { value: "TwoWeeks", text: "2 weeks" },
        { value: "ThreeWeeks", text: "3 weeks" },
        { value: "OneMonth", text: "1 month" },
        { value: "TwoMonths", text: "2 months" },
        { value: "ThreeMonths", text: "3 months" },
        { value: "SixMonths", text: "6 months" }
      ],
      documentStatus: [
        { value: "Draft", text: "Draft" },
        { value: "Pending", text: "Pending" },
        { value: "Completed", text: "Completed" }
      ],
      formErrors: {
        name: [],
        logo: []
      }
    };
  },
  async mounted() {
    this.getData();
  },
  methods: {
    ...mapActions("layout", ["showAlertSuccess", "showError"]),
    appointmentRequestEnableToggleChangeState() {
      this.appointmentRequestEnable = !this.appointmentRequestEnable;
    },
    appointmentRequestNewPatientEnableToggleChangeState() {
      this.appointmentRequestNewPatientEnable = !this
        .appointmentRequestNewPatientEnable;
    },
    appointmentRequestNewClientScheduleSameDayToggleChangeState() {
      this.appointmentRequestNewClientScheduleSameDay = !this
        .appointmentRequestNewClientScheduleSameDay;
    },
    appointmentRequestNewPatientInformationToggleChangeState() {
      this.appointmentRequestNewPatientInformation = !this
        .appointmentRequestNewPatientInformation;
    },
    async getData() {
      const response = await systemSettingServer.get();
      this.placeAppointmentsSelect = response.appointmentRequestPlaceTimeLogic
        ? response.appointmentRequestPlaceTimeLogic
        : "ByServiceDuration";
      this.patientPortalDefaultDocumentStatus = response.patientPortalDefaultDocumentStatus
        ? response.patientPortalDefaultDocumentStatus
        : "Pending";
      this.availableTimeBeforeSelect = response.appointmentRequestAvailableTimeBefore
        ? response.appointmentRequestAvailableTimeBefore
        : "OneHour";
      this.availableTimeInAdvanceSelect = response.appointmentRequestAvailableTimeInAdvance
        ? response.appointmentRequestAvailableTimeInAdvance
        : "SixMonths";
      this.appointmentRequestEnable = response.appointmentRequestEnable;
      this.appointmentRequestNewPatientEnable =
        response.appointmentRequestNewPatientEnable;
      this.appointmentRequestNewPatientInformation =
        response.appointmentRequestNewPatientInformation;
      this.appointmentRequestNewClientScheduleSameDay =
        response.appointmentRequestNewClientScheduleSameDay;
    },
    async updateData() {
      const data = {
        appointmentRequestavailableTimeBefore: this.availableTimeBeforeSelect,
        appointmentRequestavailableTimeInAdvance: this
          .availableTimeInAdvanceSelect,
        appointmentRequestPlaceTimeLogic: this.placeAppointmentsSelect,
        appointmentRequestEnable: this.appointmentRequestEnable,
        appointmentRequestNewPatientEnable: this
          .appointmentRequestNewPatientEnable,
        appointmentRequestNewPatientInformation: this
          .appointmentRequestNewPatientInformation,
        appointmentRequestNewClientScheduleSameDay: this
          .appointmentRequestNewClientScheduleSameDay,
        patientPortalDefaultDocumentStatus: this
          .patientPortalDefaultDocumentStatus
      };
      await systemSettingServer
        .update(data)
        .then(() => {
          this.showAlertSuccess();
        })
        .catch(error => {
          this.showError({
            message: error.response.data
          });
        });
    }
  },
  computed: {
    ...mapState("layout", {
      selectedLocationObj: state => state.selectedLocationObj
    })
  }
};
</script>
